// eslint-disable-next-line max-len
export const MuiCircularProgress = (palette) => ({ root: { svg: { stroke: palette.semantic.colorPrimary } } });
